<template>
    <div class="nonmember2" v-if="contShow">
        <div class="topCeng2">
            <div class="men_world2">{{msgs}}</div>
            <van-button round type="primary" size="small" style="padding:0px 0.8rem;" @click="back">返回</van-button>
        </div>
    </div>
</template>

<script>
export default {
    props:["codeHtmlShow","msg"],
    data() {
        return {
            contShow: this.codeHtmlShow, //显示
            msgs: this.msg, //显示
        };
    },
    methods: {
        codeHtmlFun(show,msg){
            this.contShow=show;
            this.msgs=msg;
        },
        //返回上一层
        back(){
            this.$router.go(-1);
        },
    },
};
</script>

<style>
.nonmember2{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.8);
    position:absolute;
    top:0px;
    left:0px;
    z-index:99999;
    text-align:center;
}
.topCeng2{
    margin-top:50%;
}
.men_world2{
    line-height:1rem;
    margin:1rem 0rem 1.2rem;
    color:#ECECEC;
    font-size:0.8rem;
}
</style>